import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import IOnProcessDashboardDTO from "../../../models/DTO/IOnProcessDashboardDTO";
import IProcessDashboardDTO from "../../../models/DTO/IProcessDashboardDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IDashboard from "../../../models/IDashboard";
import INewDashboard from "../../../models/INewDashboard";
import INotification from "../../../models/INotification";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OwButton from "../../shared/OwButton/OwButton";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwToggle from "../../shared/OwToggle/OwToggle";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import DashboardTypeEnum from "../../../models/DashboardTypeEnum";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import SupplierService from "../../../services/SupplierService";
import DashboardService from "../../../services/DashboardService";

type Props = {
    cancelFn: (refreshData?: boolean) => void;
    dashboard?: IDashboard;
};

export const DashboardSidebar = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const getDashboard = (): IDashboard | INewDashboard => {
        if (props.dashboard) {
            return props.dashboard;
        } else {
            return {
                supplier_id: supplierModel.id,
                config: [],
                name: "",
                type: DashboardTypeEnum.USER,
            };
        }
    };

    const getIsDefaultVendorDashboard = () => {
        if (props.dashboard) {
            if (supplierModel.default_vendors_dashboard_id === props.dashboard.id) {
                return true;
            }
        }

        return false;
    };

    const [dashboard, setDashboard] = useState(getDashboard());
    const [isDefaultDashboard, setIsDefaultDashboard] = useState(
        DashboardService.getIsDefaultDashboard(props.dashboard, supplierModel, userModel)
    );
    // const [isDefaultVendorDashboard, setIsDefaultVendorDashboard] = useState(getIsDefaultVendorDashboard());
    // const [isDefaultUserDashboard, setIsDefaultUserDashboard] = useState(false);
    // const [isUserDashboard, setIsUserDashboard] = useState(false);
    const [createActive, setCreateActive] = useState(false);
    const typeOptions: { title: string; value: DashboardTypeEnum }[] = [
        { title: "user", value: DashboardTypeEnum.USER },
        { title: SupplierService.updateStringWithVendorOverride("vendor", supplierModel), value: DashboardTypeEnum.CUSTOMER },
        { title: "internal", value: DashboardTypeEnum.SUPPLIER },
    ];

    const onProcessDashboard = (data: IOnProcessDashboardDTO) => {
        setCreateActive(false);

        props.cancelFn(true);
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.DashboardOnProcessDashboard, fn: onProcessDashboard }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const cancel = (refreshData?: boolean) => {
        props.cancelFn(refreshData);
    };

    const create = () => {
        const payload: IProcessDashboardDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            dashboard,
            isDefaultDashboard,
        };

        socket.emit(EndpointsEnum.DashboardProcessDashboard, payload);

        setCreateActive(true);
    };

    const handleDashboardChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const updatedDashboard = {
            ...dashboard,
        };

        // @ts-expect-error
        updatedDashboard[name] = value;

        setDashboard(updatedDashboard);
    };

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        if (name === "isDefaultDashboard") {
            setIsDefaultDashboard(value);
            //     setIsUserDashboard(false);
            //     setIsDefaultVendorDashboard(false);
            // } else if (name === "isDefaultVendorDashboard") {
            //     setIsDefaultVendorDashboard(value);
            //     setIsDefaultDashboard(false);
            //     setIsUserDashboard(false);
            // } else if (name === "isUserDashboard") {
            //     setIsUserDashboard(value);
            //     setIsDefaultDashboard(false);
            //     setIsDefaultVendorDashboard(false);
        }
    };

    return (
        <div className={"DashboardSidebar p-2"}>
            <div className={"col-12"}>
                <div className="text-end">
                    <button
                        className="btn btn-danger btn-sm"
                        onClick={() => {
                            cancel();
                        }}>
                        <i className="far fa-times" />
                    </button>
                </div>
                <OwTitle className={"mb-2"} leftIconName={"fad fa-grid"} title={"dashboard"} />
                <hr />
            </div>

            <div className={"col-12 mb-3"}>
                <OwLabel title={"name"} />
                <OwInputWrapper name={"name"} fn={handleDashboardChange} value={dashboard.name} />
            </div>

            <div className="col-12 mb-3">
                <OwLabel title={"type"} />
                <OwSelectOption
                    fn={handleDashboardChange}
                    titleProp={"title"}
                    valueProp={"value"}
                    name={"type"}
                    options={typeOptions}
                    selectedOption={dashboard}
                    selectedOptionProp={"type"}
                    translateTitle={true}
                />
            </div>

            {/*<div className={"col-12 mb-3"}>*/}
            {/*    <OwToggle*/}
            {/*        disabled={isDefaultDashboard || isDefaultVendorDashboard}*/}
            {/*        fn={handleChange}*/}
            {/*        name={"isUserDashboard"}*/}
            {/*        label={"is_default_user_dashboard"}*/}
            {/*        active={isUserDashboard}*/}
            {/*        labelOnRight={true}*/}
            {/*    />*/}
            {/*</div>*/}

            <div className={"col-12 mb-3"}>
                <OwToggle
                    fn={handleChange}
                    name={"isDefaultDashboard"}
                    label={"is_default_dashboard"}
                    active={isDefaultDashboard}
                    labelOnRight={true}
                />
            </div>

            {/*<div className={"col-12 mb-3"}>*/}
            {/*    <OwToggle*/}
            {/*        disabled={isUserDashboard || isDefaultDashboard}*/}
            {/*        fn={handleChange}*/}
            {/*        name={"isDefaultVendorDashboard"}*/}
            {/*        label={"is_vendor_default_dashboard"}*/}
            {/*        active={isDefaultVendorDashboard}*/}
            {/*        isSupplierVendorOverride={true}*/}
            {/*        supplierModel={supplierModel}*/}
            {/*        labelOnRight={true}*/}
            {/*    />*/}
            {/*</div>*/}

            {/*<div className={"col-12 mb-3"}>*/}
            {/*    <OwToggle*/}
            {/*        disabled={this.state.isDefaultVendorDashboard || this.state.isDefaultDashboard}*/}
            {/*        fn={this.handleChange}*/}
            {/*        name={"isUserDashboard"}*/}
            {/*        label={"is_user_dashboard"}*/}
            {/*        active={this.state.isUserDashboard}*/}
            {/*        labelOnRight={true}*/}
            {/*    />*/}
            {/*</div>*/}

            <div>
                <OwButton title={props.dashboard ? "save" : "create"} fn={create} active={createActive} disableOnActive={true} />
            </div>
        </div>
    );
};
